import { Component } from "@angular/core";

@Component({
  selector: "solution-by-beckapp",
  templateUrl: "./solution-by-beckapp.component.html",
  styleUrls: ["./solution-by-beckapp.component.scss"],
  standalone: true,
})
export class SolutionByBeckappComponent {}
